import { render, staticRenderFns } from "./ClosedTicket.vue?vue&type=template&id=0c827f09&scoped=true&"
import script from "./ClosedTicket.vue?vue&type=script&lang=js&"
export * from "./ClosedTicket.vue?vue&type=script&lang=js&"
import style0 from "./ClosedTicket.vue?vue&type=style&index=0&id=0c827f09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c827f09",
  null
  
)

export default component.exports